import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUDistance',
	friendly_name: 'BLU Distance',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: false,
			bluetooth_settings: [
				{
					title: 'measurement_movement',
					component: 'measurement_movement_ble',
				},
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				{
					title: 'application_settings',
					components: [
						{ title: 'edit_device', component: 'edit_device' },
						{
							title: 'quick_tour_guide',
							component: 'quick_tour_guide',
						},
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'distance_range', component: 'distance_range_ble' },
						{
							title: 'measurement_interval',
							component: 'measurement_interval_ble',
						},
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
